import BaseService from "./Base"

class DocsService extends BaseService {
    async downloadExternalAPIsDocumentationPdf(): Promise<{url: string; filename: string}> {
        const response = await this.axios.request({method: "get", url: "/docs/external-apis", responseType: "blob"})

        const blob = new Blob([response.data])
        let filename = "edular-external-apis-documentation.pdf"

        // Try to extract filename from Content-Disposition header
        const contentDisposition = response.headers["content-disposition"]
        if (contentDisposition && contentDisposition.includes("filename=")) {
            filename = contentDisposition.split("filename=")[1].replace(/['"]/g, "").trim()
        }

        const url = window.URL.createObjectURL(blob)

        return {url, filename}
    }
}

export default DocsService
